import React from 'react';
import { FormattedMessage } from 'react-intl';
import { INTEGRATION_KEY, INTEGRATION_LABEL } from "../state/integration/Constants";

//Most of these are deprecated constants. Use INTEGRATION_KEY namespace instead.
export const integrationKeyAcomba = 'acomba'
export const integrationKeyAdi = 'adi'
export const integrationKeyApa = 'apa'
export const integrationKeyDandh = 'dandh'
export const integrationKeyDtools = 'd-tools'
export const integrationKeyHubspot = 'hubspot'
export const integrationKeyQuickbooks = 'quick-books'
export const integrationKeyLightspeed = 'ls-retail'
export const integrationKeyLightspeedEcom = INTEGRATION_KEY.LIGHTSPEED_ECOM
export const integrationKeyLightspeedEcomOmni = INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI
export const integrationKeyLightspeedEcomOmniNA = INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI_NA
export const integrationKeyLightspeedGolf = INTEGRATION_KEY.LIGHTSPEED_GOLF
export const integrationKeySalesforce = 'salesforce'
export const integrationKeySynnex = 'synnex'
export const integrationKeyStripe = 'stripe'
export const integrationKeyPaysafe = 'paysafe'
export const integrationKeyRainforest = 'rainforest'
export const integrationKeyKangaroo = 'kangaroo'
export const integrationKeyZapierMu2 = 'zapier-mu2'
export const integrationKeyZapier = 'zapier'
export const integrationKeyZendeskSupport = 'zendesk-support-mu2'
export const integrationKeyZendeskSell = 'zendesk-sell'
export const integrationKeyNylas = 'nylas'
export const integrationKeyShopify = INTEGRATION_KEY.SHOPIFY
export const integrationKeySquare = INTEGRATION_KEY.SQUARE
export const integrationKeyShopifyExpertApp = INTEGRATION_KEY.SHOPIFY_EXPERT_APP
export const integrationKeyVend = 'vend'
export const integrationKeyWix = INTEGRATION_KEY.WIX

const CategoryPOS = "pos"
const CategoryPayment = "payment"
const CategoryProductivity = "productivity"
const CategoryAccounting = "accounting"

export const details = [
    {
        key: INTEGRATION_KEY.LIGHTSPEED_RETAIL,
        logo: '/images/lightspeed_retail_logo.png',
        description: <FormattedMessage
            id="integration.lightspeed.description"
            defaultMessage="Sync your product catalog, inventory and contacts in real time. Export your proposal into a Sale once approved"
        />,
        name: INTEGRATION_LABEL[INTEGRATION_KEY.LIGHTSPEED_RETAIL],
        category: CategoryPOS,
        multi: false,
        //Cannot be used with other POS
        incompatibleWith: [
            INTEGRATION_KEY.SHOPIFY,
            INTEGRATION_KEY.SHOPIFY_EXPERT_APP,
            INTEGRATION_KEY.LIGHTSPEED_ECOM,
            INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI,
            INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI_NA,
        ],
        authConnect: true,
        hasFilter: true,
        labelFilter: "lightspeed_label"
    },
    {
        key: INTEGRATION_KEY.ZENDESK_SUPPORT,
        logo: '/images/zendesk_support_logo.png',
        description: <FormattedMessage
            id="integration.zendesk.support.description"
            defaultMessage="Sync your product catalog, inventory and contacts in real time. Export your proposal into a Sale once approved"
        />,
        name: INTEGRATION_LABEL[INTEGRATION_KEY.ZENDESK_SUPPORT],
        category: CategoryPOS,
        multi: false,
        //Cannot be used with other POS
        incompatibleWith: [
            INTEGRATION_KEY.LIGHTSPEED_GOLF,
            INTEGRATION_KEY.ZENDESK_SELL,
            INTEGRATION_KEY.ZENDESK_SUPPORT_MU2,
            INTEGRATION_KEY.LIGHTSPEED_ECOM,
            INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI,
            INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI_NA,
        ],
        authConnect: true,
        hasFilter: true,
        labelFilter: "zendesk_support_label"
    },
    {
        key: INTEGRATION_KEY.LIGHTSPEED_GOLF,
        logo: '/images/lsgolf_logo.svg',
        description: <FormattedMessage
            id="integration.lightspeed_golf.description"
            defaultMessage="Build eye-catching quotes and invoices for golf events and tournaments, plus manage event registrations easily"
        />,
        name: <FormattedMessage
            id="integration.lightspeed_golf.title"
            defaultMessage="Lightspeed Golf"
        />,
        category: CategoryPOS,
        multi: false,
        //Cannot be used with other POS except Lightspeed R-Series
        incompatibleWith: [
            INTEGRATION_KEY.SHOPIFY,
            INTEGRATION_KEY.SHOPIFY_EXPERT_APP,
            INTEGRATION_KEY.LIGHTSPEED_ECOM,
            INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI,
            INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI_NA,
            INTEGRATION_KEY.VEND,
            INTEGRATION_KEY.SQUARE,
        ],
        authConnect: false,
        hasFilter: true,
        labelFilter: "lightspeed_golf_label"
    },
    // {
    //     key: integrationKeyLightspeedEcomOmni,
    //     logo: '/images/lightspeed_ecom_logo.png',
    //     description: <FormattedMessage
    //         id="integration.lightspeed_ecom_omni.description"
    //         defaultMessage="Lightspeed eCom OmniChannel description"
    //     />,
    //     name: <FormattedMessage
    //         id="integration.lightspeed_ecom_omni.title"
    //         defaultMessage="Lightspeed OmniChannel"
    //     />,
    //     category: CategoryPOS,
    //     multi: false,
    //     incompatibleWith: [INTEGRATION_KEY.SHOPIFY, INTEGRATION_KEY.SHOPIFY_EXPERT_APP, INTEGRATION_KEY.LIGHTSPEED_ECOM, INTEGRATION_KEY.VEND, INTEGRATION_KEY.SQUARE],
    //     authConnect: false,
    //     hasFilter: true,
    //     labelFilter: "lightspeed_ecom_omni_label"
    // },
    {
        key: INTEGRATION_KEY.VEND,
        logo: '/images/lightspeed_logo.png',
        description: <FormattedMessage
            id="integration.vend.description"
            defaultMessage="Sync your product catalog, inventory and contacts in real time. Export your proposal into a Sale once approved"
        />,
        name: INTEGRATION_LABEL[INTEGRATION_KEY.VEND],
        category: CategoryPOS,
        multi: false,
        //Cannot be used with other POS
        incompatibleWith: [
            INTEGRATION_KEY.SHOPIFY,
            INTEGRATION_KEY.SHOPIFY_EXPERT_APP,
            INTEGRATION_KEY.LIGHTSPEED_ECOM,
            INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI,
            INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI_NA,
            INTEGRATION_KEY.LIGHTSPEED_RETAIL,
            INTEGRATION_KEY.LIGHTSPEED_GOLF,
            INTEGRATION_KEY.SQUARE,
        ],
        authConnect: true,
        hasFilter: true,
        labelFilter: "vend_label"
    },
    {
        key: INTEGRATION_KEY.LIGHTSPEED_ECOM,
        logo: '/images/lightspeed_ecom_logo.png',
        description: <FormattedMessage
            id="integration.lightspeed_ecom.description"
            defaultMessage="Lightspeed eCom description"
        />,
        name: <FormattedMessage
            id="integration.lightspeed_ecom.title"
            defaultMessage="Lightspeed eCom"
        />,
        category: CategoryPOS,
        multi: false,
        incompatibleWith: [
            INTEGRATION_KEY.SHOPIFY,
            INTEGRATION_KEY.LIGHTSPEED_RETAIL,
            INTEGRATION_KEY.SHOPIFY_EXPERT_APP,
            'orders',
        ],
        authConnect: false,
        hasFilter: true,
        labelFilter: "lightspeed_ecom_label",
        hide: true,
    },
    // {
    //     key: integrationKeyLightspeedEcomOmniNA,
    //     logo: '/images/lightspeed_ecom_logo.png',
    //     description: <FormattedMessage
    //         id="integration.lightspeed_ecom_omni_na.description"
    //         defaultMessage="Lightspeed eCom OmniChannel Na description"
    //     />,
    //     name: <FormattedMessage
    //         id="integration.lightspeed_ecom_omni_na.title"
    //         defaultMessage="Lightspeed OmniChannel North America"
    //     />,
    //     category: CategoryPOS,
    //     multi: false,
    //     incompatibleWith: [INTEGRATION_KEY.SHOPIFY, INTEGRATION_KEY.SHOPIFY_EXPERT_APP, INTEGRATION_KEY.LIGHTSPEED_ECOM, INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI, INTEGRATION_KEY.VEND, INTEGRATION_KEY.SQUARE],
    //     authConnect: false,
    //     hasFilter: true,
    //     labelFilter: "lightspeed_ecom_omni_na_label"
    // },
    {
        key: INTEGRATION_KEY.SHOPIFY,
        logo: '/images/shopify_logo.png',
        description: <FormattedMessage
            id="integration.shopify.description"
            defaultMessage="Sync your product catalog, inventory and contacts in real time."
        />,
        name: <FormattedMessage
            id="integration.shopify.title"
            defaultMessage="Shopify"
        />,
        category: CategoryPOS,
        multi: false,
        //Cannot be used with other POS including the Shopify expert app
        incompatibleWith: [
            INTEGRATION_KEY.LIGHTSPEED_RETAIL,
            INTEGRATION_KEY.LIGHTSPEED_ECOM,
            INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI,
            INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI_NA,
            INTEGRATION_KEY.SHOPIFY_EXPERT_APP,
        ],
        authConnect: true,
        hasFilter: true,
        labelFilter: "shopify_label",
        incompatibleDocuments: ['orders', 'recurring-invoices'],
    },
    {
        key: INTEGRATION_KEY.SHOPIFY_EXPERT_APP,
        logo: '/images/shopify_logo.png',
        description: <FormattedMessage
            id="integration.shopify.description"
            defaultMessage="Sync your product catalog, inventory and contacts in real time."
        />,
        name: <FormattedMessage
            id="integration.shopify.title"
            defaultMessage="Shopify"
        />,
        category: CategoryPOS,
        multi: false,
        //Cannot be used with other POS including the main Shopify
        incompatibleWith: [
            INTEGRATION_KEY.LIGHTSPEED_RETAIL,
            INTEGRATION_KEY.LIGHTSPEED_ECOM,
            INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI,
            INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI_NA,
            INTEGRATION_KEY.SHOPIFY,
        ],
        authConnect: true,
        hasFilter: true,
        labelFilter: "shopify_label",
        hide: true,
        incompatibleDocuments: ['orders', 'recurring-invoices'],
    },
    {
        key: INTEGRATION_KEY.STRIPE,
        logo: '/images/stripe_logo.png',
        description: <FormattedMessage
            id="integration.stripe.description"
            defaultMessage="Take online payment from the invoice and get paid faster. Invoice balance gets updated automatically."
        />,
        name: <FormattedMessage
            id="integration.stripe.title"
            defaultMessage="Stripe"
        />,
        category: CategoryPayment,
        multi: true,
        incompatibleWith: [
            INTEGRATION_KEY.SQUARE_PAYMENTS,
            INTEGRATION_KEY.RAINFOREST],
        hasSuperUserFilter: true,
        authConnect: true
    },
    {
        key: INTEGRATION_KEY.SQUARE,
        logo: '/images/square_logo.png',
        description: <FormattedMessage
            id="integration.square.description"
            defaultMessage="Square description please"
        />,
        name: <FormattedMessage
            id="integration.square.title"
            defaultMessage="Square"
        />,
        //also a payment gateway
        category: CategoryPOS,
        multi: false,
        //Cannot be used with other POS and payment gateways
        incompatibleWith: [
            INTEGRATION_KEY.LIGHTSPEED_RETAIL,
            INTEGRATION_KEY.SHOPIFY,
            INTEGRATION_KEY.SHOPIFY_EXPERT_APP,
            INTEGRATION_KEY.LIGHTSPEED_ECOM,
            INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI,
            INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI_NA,
            INTEGRATION_KEY.STRIPE,
            INTEGRATION_KEY.VEND,
            INTEGRATION_KEY.SQUARE_PAYMENTS,
        ],
        authConnect: true,
        hasFilter: false,
        labelFilter: "square_label"
    },
    {
        key: INTEGRATION_KEY.SQUARE_PAYMENTS,
        logo: '/images/square_logo.png',
        description: <FormattedMessage
            id="integration.square_payments.description"
            defaultMessage="Take online payment from the invoice and get paid faster. Invoice balance gets updated automatically."
        />,
        name: <FormattedMessage
            id="integration.square_payments.title"
            defaultMessage="Square Payments"
        />,
        //Square but without POS features so only payment
        category: CategoryPayment,
        //cannot have more than one Square payment integration for now so all locations will use the same one
        multi: false,
        incompatibleWith: [
            INTEGRATION_KEY.SQUARE,
            INTEGRATION_KEY.RAINFOREST,
            INTEGRATION_KEY.STRIPE],
        hasSuperUserFilter: true,
        authConnect: true
    },
    {
        key: INTEGRATION_KEY.QUICK_BOOKS,
        logo: '/images/quickbooks_logo.png',
        description: <FormattedMessage
            id="integration.quickbooks.description"
            defaultMessage="Export approved quotes to Acomba. Import product list."
        />,
        name: <FormattedMessage
            id="integration.quickbooks.title"
            defaultMessage="QuickBooks"
        />,
        category: CategoryAccounting,
        multi: false,
        incompatibleWith: [],
        authConnect: true,
        hasFilter: true,
        labelFilter: "quickbooks_label"
    },
    {
        key: INTEGRATION_KEY.KANGAROO,
        logo: '/images/kangaroo_logo.png',
        description: <FormattedMessage
            id="integration.kangaroo.description"
            defaultMessage="Get loyalty point balance and capability to redeem points to discounts"
        />,
        name: <FormattedMessage
            id="integration.kangaroo.title"
            defaultMessage="Kangaroo Rewards"
        />,
        //Can also act as a POS. If used along with another POS, some POS features need to be disabled.
        category: CategoryProductivity,
        multi: false,
        incompatibleWith: [],
        authConnect: true
    },
    {
        key: INTEGRATION_KEY.ZAPIER,
        logo: '/images/zapier_logo.png',
        description: <FormattedMessage
            id="integration.zapier.description"
            defaultMessage="Triggers and actions in Zapier. Integrate 2,000+ apps"
        />,
        name: <FormattedMessage
            id="integration.zapier.title_original"
            defaultMessage="Zapier"
        />,
        category: CategoryProductivity,
        multi: false,
        incompatibleWith: [],
        authConnect: false
    },
    // {
    //     key: integrationKeyZendeskSupport,
    //     logo: '/images/zendesk_support_logo.png',
    //     description: <FormattedMessage
    //         id="integration.zendesk_support.description"
    //         defaultMessage="Create quotes directly on a customer service software featuring an email ticketing system for a better customer experience (Powered by MU2)."
    //     />,
    //     name: <FormattedMessage
    //         id="integration.zendesk_support.title"
    //         defaultMessage="Zendesk Support"
    //     />,
    //     category: CategoryProductivity,
    //     multi: false,
    //     incompatibleWith: [],
    //     authConnect: false
    // },
    {
        key: INTEGRATION_KEY.ZENDESK_SELL,
        logo: '/images/zendesk_sell_logo.png',
        description: <FormattedMessage
            id="integration.sendesk_sell.description"
            defaultMessage="Create quotes directly from Zendesk Sell using smart links."
        />,
        name: <FormattedMessage
            id="integration.sendesk_sell.title"
            defaultMessage="Zendesk Sell"
        />,
        category: CategoryProductivity,
        multi: false,
        incompatibleWith: [],
        authConnect: true
    },
    {
        key: INTEGRATION_KEY.PIPEDRIVE,
        logo: '/images/pipedrive_logo.png',
        description: <FormattedMessage
            id="integration.pipedrive.description"
            defaultMessage="Create quotes, invoices and orders directly from Pipedrive deals."
        />,
        name: <FormattedMessage
            id="integration.pipedrive.title"
            defaultMessage="Pipedrive"
        />,
        category: CategoryProductivity,
        multi: true,
        incompatibleWith: [],
        authConnect: true,
    },
    // {
    //     key: INTEGRATION_KEY.WIX,
    //     logo: '/images/wix_logo.png',
    //     description: <FormattedMessage
    //         id="integration.wix.description"
    //         defaultMessage="Sync your product catalog, invoices, inventory and contacts in real time."
    //     />,
    //     name: <FormattedMessage
    //         id="integration.wix.title"
    //         defaultMessage="Wix"
    //     />,
    //     category: CategoryPOS,
    //     multi: false,
    //     //Cannot be used with other POS including the main Shopify
    //     incompatibleWith: [
    //         INTEGRATION_KEY.LIGHTSPEED_RETAIL,
    //         INTEGRATION_KEY.LIGHTSPEED_ECOM,
    //         INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI,
    //         INTEGRATION_KEY.LIGHTSPEED_ECOM_OMNI_NA,
    //         INTEGRATION_KEY.SHOPIFY,
    //     ],
    //     authConnect: true,
    //     hasFilter: true,
    //     labelFilter: "wix_label",
    //     hide: false,
    //     incompatibleDocuments: [],
    // },
    {
        key: INTEGRATION_KEY.HUBSPOT,
        logo: '/images/hubspot_logo.svg',
        description: <FormattedMessage
            id="integration.hubspot.description"
            defaultMessage="Create quotes, invoices and orders directly from HubSpot deals."
        />,
        name: "HubSpot",
        category: CategoryProductivity,
        multi: false,
        incompatibleWith: [],
        authConnect: true,
    },
    {
        key: INTEGRATION_KEY.MAILCHIMP,
        logo: '/images/mailchimp_logo_cropped.png',
        description: <FormattedMessage
            id="integration.mailchimp.description"
            defaultMessage="Export data to mailchimp."
        />,
        name: <FormattedMessage
            id="integration.mailchimp.title"
            defaultMessage="Mailchimp"
        />,
        category: CategoryProductivity,
        multi: true,
        incompatibleWith: [],
        authConnect: true,
    },
    {
        key: INTEGRATION_KEY.FRESHBOOKS,
        logo: '/images/freshbooks_logo.png',
        description: <FormattedMessage
            id="integration.freshbooks.description"
            defaultMessage="FreshBooks integration"
        />,
        name: <FormattedMessage
            id="integration.freshbooks.title"
            defaultMessage="FreshBooks"
        />,
        category: CategoryAccounting,
        multi: false,
        //might need to make incompatible with other POS
        incompatibleWith: [
            INTEGRATION_KEY.QUICK_BOOKS,
        ],
        authConnect: true,
        hasFilter: true,
        labelFilter: "freshbooks_label",
        //to remove when integration is ready
        hideOnProduction: true,
    },
]


// WEBPACK FOOTER //
// ./src/integration/IntegrationConstants.jsx